import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import Swal from 'sweetalert2';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, convertToNumber, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const SuccessPaymentReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    let [result, setResult] = useState([]);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [loading, setLoading] = useState(false);
    const inputrefs = useRef([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const commonData = CommonApiData();
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let oneMonthAgoDate = new Date(pqrDate);
    oneMonthAgoDate.setMonth(pqrDate.getMonth() - 1);

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "dealerCode": commonData.DealerCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
    })

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            "fromDate": dateArr,
            "toDate": dateArr,
        })
        filterData.SearchText = ''
        filterData.AdvanceFilter = []
        setSortConfig({ SortColumn: null, SortOrder: null })
        inputrefs.current['txtFromDate'].focus()
    }

    let PageName = 'Payment Success Report'
    const handleChange1 = (event, value) => {
        GetSuccessPaymentReport(value);
    };


    const GetSuccessPaymentReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Report/SuccessfulPaymentReport', GetData)
        setLoading(false)
        if (data.Status === 'SUCCESS') {
            setResult(data)
        }
        else if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        else {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        setResult(data)
    }
    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    useEffect(() => {
        GetSuccessPaymentReport();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Payment Success Report'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Payment Success Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            required={true}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            required={true}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    Data.dealerCode ?
                                        inputrefs.current['txtProductCode'].focus() :
                                        inputrefs.current['txtDealer'].focus();
                                };
                            }}
                        />

                        <div className='d-block mt-3 d-md-flex' >
                            <button
                                ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                                onClick={GetSuccessPaymentReport}
                                className="btn btn-rounded btn-primary">
                                <span className=" text-white me-2">
                                    <i className="fa fa-search"></i>
                                </span>Search</button>
                            <button
                                className="btn btn-rounded btn-warning"
                                onClick={async () => {
                                    try {
                                        dispatch(setSubLoading(true))
                                        await handleDownloadExcel('/api/Report/SuccessfulPaymentReport', ExportRequest, 'Successful Payment Cases Report');
                                        dispatch(setSubLoading(false))

                                    } finally {
                                        dispatch(setSubLoading(false))
                                    }
                                }}
                            >
                                <span className="text-warning me-2">
                                    <i className="fa fa-download text-white color-success"></i>
                                </span>
                                Export
                            </button>
                            <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                            </span>Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            <Table
                PageName={PageName}
                loading={loading}
                handleFilter={() => {
                    GetSuccessPaymentReport()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                setFilterData={setFilterData}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />
        </>
    )
}
export default SuccessPaymentReport;